import { formatDesignElementVersion } from "../../domain/designElementVersion";

type LinkedElement = {
  version: string;
  major?: number | null;
  minor?: number | null;
};

export const linkedElementVersionPath = (
  row: LinkedElement,
  versioned: boolean,
): string => {
  if (versioned) {
    return `/version/${row.version}`;
  }

  const label = formatDesignElementVersion(row.major, row.minor);
  return label ? `/version/v${label}` : "";
};
